import { TableWithRowAnimation } from 'components/base-table'

import type { INicheTableView } from './niche-table.types'
import './niche-table.styles.scss'

export const NicheTableView = ({ headers, niches, onRowClick }: INicheTableView) => {
  return (
    <div className="NicheTable">
      <TableWithRowAnimation headers={headers} data={niches} defaultSort="avgEngagement" onClick={onRowClick} />
    </div>
  )
}
